import React, {useState, useEffect, Suspense} from 'react'
import { Layout, ConfigProvider, theme} from 'antd'
import 'antd/dist/reset.css'
import './i18n';

import './index.css'

import {useAuth} from "./hooks/auth.hook"
import {AuthContext} from "./context/AuthContext";
import { mainRoutes } from "./routes/routesData";


import {RouterProvider, useNavigate} from 'react-router-dom';

import locale from "antd/es/locale/ru_RU";
import dayjs from "dayjs";
import 'dayjs/locale/uz';
import ChartQueryContextProvider from "./context/chartQueryContext/ChartQueryContextProvider";
import RecentlyComeMenusProvider from "./context/recentlyComeMenus/RecentlyComeMenusProvider";
import {FilterProvider} from "./context/FilterContext";
import {useTheme} from "./context/ThemeContext";
import {TitleContext, useTitle} from "./context/TitleContext";
import {useTranslation} from "react-i18next";
import {useAutoLogOut} from "./hooks/useAutoLogOut";

const AppRoutes = ({ routes, logout }) => {

    const [lastActivityTime, setLastActivityTime] = useState(new Date());

    const updateLastActivityTime = () => {
        setLastActivityTime(new Date());
    };

    const navigate = useNavigate();

    const fiveMinutes = 5 * 60 * 1000; // 5 minutes in milliseconds
    const oneMinute = 60 * 1000; // 1 minutes in milliseconds
    //const fiveMinutes = 6000; // 5 minutes in milliseconds
    //const oneMinute = 6000; // 1 minutes in milliseconds

    useEffect(() => {
        const handleUserActivity = () => {
            updateLastActivityTime();
        };

        document.addEventListener('mousemove', handleUserActivity);
        document.addEventListener('keydown', handleUserActivity);

        const checkInactivity = async () => {

            const currentPageLocation = window.location.pathname;

            if (currentPageLocation !== '/') {
                const currentTime = new Date();
                const inactiveTime = currentTime - lastActivityTime;

                if (inactiveTime > fiveMinutes) {
                    await logout()
                    console.log('logout')
                    navigate('/');

                }
            }
        };

        const inactivityInterval = setInterval(checkInactivity, oneMinute);

        return () => {
            document.removeEventListener('mousemove', handleUserActivity);
            document.removeEventListener('keydown', handleUserActivity);
            clearInterval(inactivityInterval);
        };
    }, [lastActivityTime, logout, navigate]);


    return (
        <Layout style={{width:'100%', height:'100%', backgroundColor:'#c6c6c6'}}>
            <div style={{width:'100%', height:'100%', backgroundColor:'#c6c6c6'}}>
                {routes}
            </div>
        </Layout>)
}

function App() {

    dayjs.locale('uz');

    const { t, i18n } = useTranslation();

    /*window.onbeforeunload = (event) => {
    const e = event || window.event;
    e.preventDefault();
    if (e) {
      e.returnValue = "";
    }
    return "";
    };*/  // NUJEN DLYA OSTATSYA ILI UYTI SO STRANICI

    const { isDarkMode} = useTheme();
    const { darkAlgorithm, defaultAlgorithm } = theme;

    const [titleNav, setTitleNav] = useState('');

    const {token, login, logout, saveFilialName, userId, ready, empId, empFilial, empName, filialName, empInn, } = useAuth();
    const isAuthenticated = !!token;

    useAutoLogOut(logout,isAuthenticated)

    useEffect(() => {
        const savedLang = localStorage.getItem('lang') || 'uz';
        i18n.changeLanguage(savedLang.toLowerCase());
    }, []);

    const customComponentColors = {
        Table: {
            //rowHoverBg: "#6bc735",
            //rowSelectedBg: "#114f50",
            //rowSelectedHoverBg: "#0e5f61"
        }
    }

    const tokenMbilling = {
        "colorPrimary": "#d89614",
        "colorInfo": "#03859a",
        "colorSuccess": "#59d31c",
        "colorWarning": "#dcb057",
        "colorError": "#ed6b21",
        //"colorTextBase": "#050505",
        "borderRadius": 6,
        "wireframe": false,
        //"colorBgBase": "#ffffff",
        algorithm: "defaultAlgorithm"
    }

  return (

      <Layout style={{width:'100vw', height:'100vh' }}>
        <AuthContext.Provider value={{
          token, login, logout, saveFilialName, userId, isAuthenticated, empId, empFilial, empName, filialName, empInn, ready
        }}>
          <ConfigProvider
              theme={
                  {
                      algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
                      token: tokenMbilling,
                      components: isDarkMode
                          ? customComponentColors
                          : {
                                Table: {
                                    //rowSelectedHoverBg: 'keremas',  //#MBILLING
                                }
                          }

                  }
              }
              locale={locale}
          >
            <FilterProvider>
                  <ChartQueryContextProvider>
                      <RecentlyComeMenusProvider>
                          <TitleContext.Provider value={{ titleNav, setTitleNav }}>

                              {/*{ isAuthenticated && ready && <NavigationBar style={{width:'100%', height:'100%', backgroundColor:'red'}} /> }*/}

                                {/*<Layout style={{width:'100%', height:'100%', backgroundColor:'#c6c6c6'}}>

                    <div style={{width:'100%', height:'100%', backgroundColor:'#c6c6c6'}}>
                      {routes}
                    </div>

                              </Layout>*/}



                                    <>
                                {/*<TitleUpdater />*/}
                                {/*<AppRoutes routes={mainRoutes} logout={logout}/>*/}
                                        <Suspense fallback={<div>Юкланмокда...</div>}>
                                            <RouterProvider router={mainRoutes}/>
                                        </Suspense>

                                    </>


                          </TitleContext.Provider>
                      </RecentlyComeMenusProvider>
                  </ChartQueryContextProvider>
            </FilterProvider>

          </ConfigProvider>

        </AuthContext.Provider>

      </Layout>

  );
}

export default App;
